export const environment = {
  clientName: 'LambdastaticSmashApp',
  production: true,
  local: false,
  prefixUrl: '',
  version: require('../../package.json').version,
  mock: false,
  stripeKey: 'pk_live_2RheUfmenIOBfEcCaMlaqnTs',
  cgu: {
    version: require('../../package.json').cgu.version,
    updated: require('../../package.json').cgu.updated,
  },
  googleTagManagerId: 'GTM-TN9DT8V',
  googleTagManagerPreview: 'env-1',
  googleTagManagerAuth: '_19GDOjeSMnbWIyv2zGkvQ',
  LambdastaticSmashAppUserAccessKey: 'AKIAYPP7RU2RCUMUXEMV',
  LambdastaticSmashAppUserSecretKey: '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',
  additionalModules: [],
  captchaKey: '6LcbojImAAAAAALTFPcakjz_gtu5SWl2OoBB6Ow8',
  appDomainWithProtocol: 'https://fromsmash.com',
  appDomain: 'fromsmash.com',
};
